// extracted by mini-css-extract-plugin
export default {"imageWrapper":"uR-z","hovered":"vR-z","hoverImage":"wR-z","mainImage":"xR-z","imageNoBackground":"yR-z","fullSizeImage":"zR-z"};